<template>
  <div>
    <span>添加</span>
    <el-form
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
      label-width="160px"
      class="demo-ruleForm"
    >
      <el-form-item label="结算日期:" prop="balancedate">
        <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="ruleForm.balancedate"></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="客户名称:" prop="customername">
        <el-input v-model="ruleForm.customername"></el-input>
      </el-form-item>-->
      <el-form-item label="客户名称:">
        <el-select v-model="ruleForm.customername" placeholder="请选择客户">
          <el-option
            v-for="item in localized"
            :key="item.id"
            :label="item.customername"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="区域:">
        <el-select v-model="ruleForm.area" placeholder="请选择省">
          <el-option v-for="item in localized" :key="item.id" :label="item.region" :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="区域:" prop="area">
          <el-select v-model="ruleForm.area" placeholder="请选择省">
            <el-option
              v-for="item in areaLeft"
              :key="item.id"
              :label="item.region"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      <el-form-item label="交易电量(kW·h):">
        <el-input v-model="ruleForm.electric" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="实际用电量(kW·h):">
        <el-input v-model="ruleForm.practical" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="偏差电量(kW·h):">
        <el-input v-model="ruleForm.power" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="偏差率(%):">
        <el-input v-model="ruleForm.deviationratio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="允许偏差电量:">
        <el-input v-model="ruleForm.bias"></el-input>
      </el-form-item>
      <el-form-item label="考核执行偏差:">
        <el-input v-model="ruleForm.assess"></el-input>
      </el-form-item>
      <el-form-item label="偏差考核费用:">
        <el-input v-model="ruleForm.deviation" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="用户考核偏差费用:">
        <el-input v-model="ruleForm.userfees" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="代理售电公司考核费用:">
        <el-input v-model="ruleForm.companyexpense" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="优惠金额:">
        <el-input v-model="ruleForm.discount" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="合计优惠金额:">
        <el-input v-model="ruleForm.totaldiscount" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input type="textarea" v-model="ruleForm.remake"></el-input>
      </el-form-item>
      <el-form-item style="width:80%;">
        <el-button @click="$router.back(-1)">取消</el-button>
        <el-button type="primary" @click="electricSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ElectricAdd",
  data() {
    return {
      localized: [], //遍历客户数组
      areaLeft: [], //遍历区域
      ruleForm: {
        area: '',
        balancedate: "",
        customername: "",
        region: "",
        electric: "",
        practical: "",
        power: "",
        deviationratio: "",
        bias: "",
        assess: "",
        deviation: "",
        userfees: "",
        companyexpense: "",
        discount: "",
        totaldiscount: "",
        remark: ""
      },
      rules: {
        balancedate: [
          { required: true, message: "请输入结算日期", trigger: "blur" }
        ],
        customername: [
          { required: true, message: "请输入客户名称", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    //客户查询
    this.provinceQuery();
    //区域查询
    this.agentEnquiries();
  },
  methods: {
    //调取后端客户接口
    provinceQuery: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "/Deal/QueryClient"
      }).then(res => {
        this.localized = res.data;
      })
    },
    //调取后端区域接口
    agentEnquiries: function() {
      const data = {};
      this.$http({
        method: "post",
        url: "Client/Linkage"
      }).then(res => {
        this.areaLeft = res.data;
      });
    },
    //保存按钮
    electricSubmit() {
      this.$http({
        method: "POST",
        url: "/Deal/Add",
        data: {
          area: this.ruleForm.area,
          balancedate: this.ruleForm.balancedate, //结算日期
          customerid: this.ruleForm.customername, //客户关联
          electric: this.ruleForm.electric, //交易电量
          practical: this.ruleForm.practical, //实际交易电量
          power: this.ruleForm.power, //偏差电量
          deviationratio: this.ruleForm.deviationratio, //偏差率
          assess: this.ruleForm.assess, //考核执行偏差
          deviation: this.ruleForm.deviation, //偏差考核费用
          userfees: this.ruleForm.userfees, //用户偏差考核费用
          companyexpense: this.ruleForm.companyexpense, //代理公司考核费用
          discount: this.ruleForm.discount, //优惠金额
          totaldiscount: this.ruleForm.totaldiscount, //合计优惠金额
          remake: this.ruleForm.remake ,//备注
          bias: this.ruleForm.bias //允许偏差电量
        }
      }).then(res => {
        console.log(res)
        this.$message({
          type: "success",
          message: "保存成功"
        });
        this.$router.push({ path: "../electric" });
      });
    }
  }
};
</script>

<style lang='less' scoped>
.el-form {
  margin: 30px 30px;
}
.el-form-item {
  width: 500px;
  display: inline-block;
  margin-left: 20px;
}
</style>
